// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

export async function searchUsers(
  s: string,
  roleId: number | undefined,
  userId: string | undefined,
  options?: { [key: string]: any },
) {
  const data: any = {
    $or: [
      {
        username: { $cont: s },
      },
      {
        email: { $cont: s },
      },
      {
        fullname: { $cont: s },
      },
    ],
  };
  if (roleId) {
    data.$and = [{ roleId }];
  }
  if (userId) {
    data.$and.push({ id: { $ne: userId } });
  }
  return request<API.UserListItem[]>('/users', {
    method: 'GET',
    params: {
      s: data,
    },
    ...(options || {}),
  });
}

/** 获取规则列表 GET /roles */
export async function users(p: API.UserQueryParams, options?: { [key: string]: any }) {
  const params: Record<string, any> = {
    limit: p.pageSize,
    page: p.current,
  };
  const andConditions: any[] = [];
  const data: any = {};
  if (p?.username?.trim()) {
    andConditions.push({ username: { $cont: p.username } });
  }
  if (p?.fullname?.trim()) {
    andConditions.push({ fullname: { $cont: p.fullname } });
  }
  if (p?.agencyName?.trim()) {
    andConditions.push({ agencyName: { $cont: p.agencyName } });
  }
  if (p?.businessCode?.trim()) {
    andConditions.push({ businessCode: { $cont: p.businessCode } });
  }
  if (p?.email?.trim()) {
    andConditions.push({ email: { $cont: p.email } });
  }
  if (p?.birthday) {
    andConditions.push({ birthday: p.birthday });
  }
  if (p?.phone?.trim()) {
    andConditions.push({ phone: { $cont: p.phone } });
  }
  if (p?.address?.trim()) {
    andConditions.push({ address: { $cont: p.address } });
  }
  if (typeof p?.isActive === 'boolean') {
    andConditions.push({ isActive: p.isActive });
  }
  const normalizedRoleId =
    typeof p?.roleId === 'number'
      ? p.roleId
      : typeof (p as any)?.roleId === 'string' && (p as any).roleId.trim() !== ''
        ? Number((p as any).roleId)
        : undefined;

  if (typeof normalizedRoleId === 'number' && !Number.isNaN(normalizedRoleId)) {
    andConditions.push({ roleId: normalizedRoleId });
  }
  if (p?.agentId?.trim()) {
    andConditions.push({
      $or: [{ id: { $eq: p.agentId } }, { ['role.agentId']: { $eq: p.agentId } }],
    });
  }

  if (andConditions.length > 0) {
    data.$and = andConditions;
    params['s'] = data;
  }
  return request<API.UserList>('/users', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 新建规则 PUT /api/rule */
export async function updateUser(
  id: string | undefined,
  data: API.UserUpdateForm,
  options?: { [key: string]: any },
) {
  return request<API.UserListItem>(`/users/${id}`, {
    method: 'PATCH',
    data,
    ...(options || {}),
  });
}

/** 新建规则 POST /api/rule */
export async function addUser(data: API.UserCreateForm, options?: { [key: string]: any }) {
  return request<API.UserListItem>('/users', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 删除规则 DELETE /api/rule */
export async function banUnBanUser(
  id: string,
  isActive: boolean,
  options?: { [key: string]: any },
) {
  return request<Record<string, any>>(`/users/ban/${id}`, {
    method: 'PATCH',
    data: {
      isActive,
    },
    ...(options || {}),
  });
}

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  return request<API.CurrentUser>('/me', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function queryPermission(options?: { [key: string]: any }) {
  return request<string[]>('/me/permissions', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function updateMe(data: API.UserUpdateForm, options?: { [key: string]: any }) {
  return request<API.UserListItem>(`/me`, {
    method: 'PATCH',
    data,
    ...(options || {}),
  });
}

export async function updatePasswordMe(
  data: API.UserUpdatePasswordForm,
  options?: { [key: string]: any },
) {
  return request<API.ResSuccess>(`/me/password`, {
    method: 'PATCH',
    data,
    ...(options || {}),
  });
}

export async function updatePasswordBackupMe(
  data: API.UserUpdatePasswordForm,
  options?: { [key: string]: any },
) {
  return request<API.ResSuccess>(`/me/password-backup`, {
    method: 'PATCH',
    data,
    ...(options || {}),
  });
}

export async function updateBizEkycPasswordMe(
  data: API.UserUpdatePasswordForm,
  options?: { [key: string]: any },
) {
  return request<API.ResSuccess>(`/me/biz-ekyc-password`, {
    method: 'PATCH',
    data,
    ...(options || {}),
  });
}

export async function queryCheckBackupPassword() {
  return request<{
    required: boolean;
  }>('/me/check-backup-password', {
    method: 'GET',
  });
}

export async function searchAgents(s: {
  keyWords: string | undefined;
  inlist: string[] | undefined;
  showRole: boolean | undefined;
  noCheckNullAgent: boolean | undefined;
}): Promise<{ value: string; label: string }[]> {
  let whereInList: string[] = ['agency', 'agency_2'];
  if (s.inlist) {
    whereInList.push(...s.inlist);
  }
  const roles = await request<API.RoleListItem[]>('/roles/search', {
    method: 'GET',
    params: {
      slug: whereInList,
    },
  });
  const roleIds: number[] | undefined = roles?.map((r: API.RoleListItem) => {
    return r.id;
  });
  // console.log(roleIds, s);
  const data: any = {};
  if (s.keyWords) {
    data.$or = [
      {
        username: { $cont: s.keyWords },
      },
      {
        email: { $cont: s.keyWords },
      },
      {
        fullname: { $cont: s.keyWords },
      },
      {
        agencyName: { $cont: s.keyWords },
      },
    ];
  }

  data.$and = [
    {
      roleId: {
        $in: roleIds,
      },
    },
  ];

  // #TC-290
  if (!s.noCheckNullAgent) {
    data.$and.push({
      agencyName: {
        $notnull: true,
      },
    });
  }
  const users = await request<API.UserList>('/users-search', {
    method: 'GET',
    params: {
      s: data,
    },
  });
  if (!users) {
    return [];
  }

  return (
    users?.data?.map((u: API.UserListItem) => {
      let label = `${u.agencyName || u.fullname || u.username}`;
      if (s.showRole) {
        label = `${label} (${u.email}) - ${u?.role?.name || ''}`;
      }
      return {
        value: u?.id || '',
        label,
      };
    }) || []
  );
}

export async function createTokenDownload() {
  return request<Promise<{ token: string }>>('/me/download', {
    method: 'POST',
  });
}

export async function deleteUsers(ids: string[]) {
  return request('/users', {
    method: 'DELETE',
    data: {
      ids,
    },
  });
}

export async function updateWebhook(data: string) {
  return request<API.ResSuccess>('/me/webhook', {
    method: 'PATCH',
    data: {
      webHook: data,
    },
  });
}
